import { Dispatch } from 'react';
import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { IReduxRootState } from '../../../app/reduxRootState.interface';
import { IAddressRequest, IAddressFieldConfig } from '../../addresses/address/address.interface';
import { ICardPostRequest, ICardPutRequest } from '../cards/card/card.interface';
import { CardsActions } from '../cards/cardsActions';
import PaymentMethodForm, {
    IPaymentMethodFormDispatchProps,
    IPaymentMethodFormOwnProps,
    IPaymentMethodFormStateProps,
} from './PaymentMethodForm';
import SupportLanguageHelper from '../../../utils/SupportLanguageHelper';
import SortHelpers from '../../../utils/sortHelpers';
import FieldHelper from '../../../utils/fieldHelper';

function mapStateToProps(
    { addresses: { addressesMap }, cards, app }: IReduxRootState,
    { card }: IPaymentMethodFormOwnProps,
) {
    const {
        locale,
        presentationConfig: {
            visibleFields: { paymethod, address },
        },
    } = app;
    const challengerDegenerate = app.appConfig.CHALLENGER_DEGENERATE;
    const addressTemplate = app.clientConfig.presentationConfig['address.template'];
    const lang = SupportLanguageHelper.getSupportLanguage(locale);
    const addressFieldConfig = Object.values(address).sort((a, b) => {
        return SortHelpers.sortAddressFieldAscendingOrder(
            a as IAddressFieldConfig,
            b as IAddressFieldConfig,
            lang,
        );
    }) as IAddressFieldConfig[];
    const groupedAddressFieldConfig = FieldHelper.groupField(addressFieldConfig);

    const privacyPolicyUrl = app.clientConfig.privacyPolicyUrl || '';
    const cardRestrictionEnabled = app.appConfig.CARD_RESTRICTION_ENABLED ?? true;

    return {
        challengerPid: app.appConfig.CHALLENGER_ENABLED
            ? app.appConfig.CHALLENGER_PIDS.PAYMENTS
            : '',
        locale: locale,
        addresses: addressesMap ? Object.values(addressesMap) : [],
        billingAddress: addressesMap && card ? addressesMap[card.addressUuid] : undefined,
        loading: cards.loading,
        defaultCountry: app.clientConfig.countryCode,
        region: app.appConfig.REGION,
        paymethod: paymethod,
        challengerDegenerate,
        addressFieldConfig: groupedAddressFieldConfig,
        addressTemplate,
        serviceName: app.clientConfig.fullName || 'Rakuten',
        privacyPolicyUrl,
        cardRestrictionEnabled,
    };
}

function mapDispatchToProps(dispatch: Dispatch<AnyAction>) {
    return {
        addCard: (card: ICardPostRequest) => {
            dispatch(CardsActions.addCard(card));
        },
        addCardWithNewAddress: (
            card: ICardPutRequest | ICardPostRequest,
            address: IAddressRequest,
            updateCardToken = '',
        ) => {
            dispatch(CardsActions.addCardWithNewAddress(card, address, updateCardToken));
        },
        updateCard: (cardToken: string, card: ICardPutRequest) => {
            dispatch(CardsActions.updateCard(cardToken, card));
        },
    };
}

const PaymentMethodFormContainer = connect<
    IPaymentMethodFormStateProps,
    IPaymentMethodFormDispatchProps,
    IPaymentMethodFormOwnProps,
    IReduxRootState
>(
    mapStateToProps,
    mapDispatchToProps,
)(PaymentMethodForm);

export default PaymentMethodFormContainer;
